<div class="accordion" id="accordionExample" style="margin-top: -25px;">
    <div class="accordion-item">
        <h2 class="accordion-header" id="heading0">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse0" aria-expanded="false" aria-controls="collapse0">
                Alimentatie
            </button>
        </h2>
        <div id="collapse0" class="accordion-collapse collapse" aria-labelledby="heading0"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                Het gaat hier om in {{ this.year }} ont=vangen partneralimentatie ontving. Dit kunnen periodieke
                betalingen zijn, bijvoorbeeld elke maand, of een bedrag ineens (afkoopsom).
                <div class="space10"></div>

                De vraag is ook van toepassing als de aangever in de woning woonde waarvan de ex-partner (mede-)eigenaar
                was en als de aangever geen huur betaalde aan de ex-partner. Deze afspraak moet onderdeel zijn van de
                afspraken die aangever heeft gemaakt met de ex-partner over het voorzien in levensonderhoud.
                <div class="space10"></div>

                De alimentatie die aangever voor de kinderen krijgt, hoef je niet aan te geven. Deze is onbelast.
                <div class="space10"></div>

                De partneralimentatie die aangever via de Sociale Dienst krijgt, vul je niet in bij deze vraag
                'Alimentatie', maar bij 'Pensioen en andere uitkeringen'.
            </div>
        </div>
    </div>


    <div class="accordion-item">
        <h2 class="accordion-header" id="heading1">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse1" aria-expanded="false" aria-controls="collapse1">
                Wat is 'partneralimentatie'
            </button>
        </h2>
        <div id="collapse11" class="accordion-collapse collapse" aria-labelledby="heading1"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                Voor de aangifte verstaan we onder ontvangen (partner)alimentatie:

                <li class="list">partneralimentatie die aangever voor zichzelf kreeg van de ex-partner</li>
                <li class="list">ouderdomspensioen dat de ex-partner aan aangever doorbetaalde</li>
                <li class="list">afkoopsommen van partneralimentatie die aangever voor zichzelf kreeg van de ex-partner</li>
                <li class="list">huur die de ex-partner voor de huurwoning doorbetaalde</li>
                <li class="list">rente die de ex-partner betaalde over aangevers deel van de eigenwoningschuldHet bedrag dat aangever
                    heeft geleend voor de aankoop, het onderhoud of de verbetering van de eigen woning of voor de afkoop
                    van erfpacht en die aan een aantal voorwaarden voldoet.<br/>
                    Aangever mag de rente alleen aftrekken als de ex-partner deze betaalde op grond van de
                    onderhoudsverplichting tegenover aangever. Dit kan aangever zelf met de ex-partner overeengekomen
                    zijn, of de ex-partner is hiertoe verplicht door de rechter.
                </li>
                <li class="list">bedragen die v kreeg voor verrekening van pensioenrechten of lijfrenten waarvoor premies zijn
                    afgetrokken
                </li>
                <li class="list">het eigenwoningforfaitEen percentage van de WOZ-waarde van aangevers woning. Aangever moet dit
                    bedrag bij het inkomen tellen. <br/>
                    Aangever geeft dit alleen aan in de rubriek 'Partneralimentatie' als aangever woont in een woning
                    waarvan de ex-partner volledig eigenaar is en aangever hiervoor geen huur betaalt. Is aangever samen
                    met de ex-partner eigenaar van de woning? Dan geeft aangever zijn deel van het eigenwoningforfait
                    aan in de rubriek 'Woningen'. Het deel van het eigenwoningforfait van de ex-partner vult
                    aangever bij deze rubriek 'Alimentatie' in.
                </li>
                <li class="list">alle (hypotheek)rente die de ex-partner als onderhoudsverplichting voor aangever betaalde voor
                    aangevers deel van de eigenwoningschuld.<br/>
                    Is bijvoorbeeld de woning maar voor de helft van u? En betaalt de ex-partner aangevers deel van deze
                    hypotheekrente? Dan geeft aangever die rente aan als ontvangen onderhoudsverplichting. Aangever mag
                    dat bedrag vervolgens ook weer aftrekken als rente van de eigenwoningschuld.
                </li>

                Het voorgaande geldt alleen als aangever deze uitkeringen of verstrekkingen in {{ this.year }} op grond
                van een (voorlopige) alimentatieregeling kreeg.
            </div>
        </div>
    </div>

    <div class="accordion-item">
        <h2 class="accordion-header" id="heading2">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse2" aria-expanded="false" aria-controls="collapse2">
                Aftrekbare kosten
            </button>
        </h2>
        <div id="collapse2" class="accordion-collapse collapse" aria-labelledby="heading2"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                Maakte aangever kosten om partneralimentatie en afkoopsommen daarvan te krijgen of te behouden? Dan mag
                hij deze kosten aftrekken. Het gaat bijvoorbeeld om:
                <li class="list">advocaatkosten</li>
                <li class="list">telefoonkosten</li>
                <li class="list">portokosten</li>
                <li class="list">reiskosten</li>
                <li class="list">incassokosten</li>
                <div class="space10"></div>

                <b>Niet-aftrekbare kosten</b><br/>
                De kosten om de echtscheiding en de boedelscheiding te regelen, mag je niet aftrekken.
            </div>
        </div>
    </div>

</div>

